import styled, {css} from 'styled-components';

import type {SelectV2} from './Select.v2';

import {getColor, ms} from '../../../styles';
import {View} from '../../View';

type SizeStyleProps = Required<Pick<SelectV2.Props, 'size'>>;

export const getSelectSizeStyles = (props: SizeStyleProps) => {
  switch (props.size) {
    case 'la':
      return css<SizeStyleProps>`
        min-height: ${ms(47)};
        height: ${ms(47)};
        min-width: ${ms(200)};
        font-size: ${ms(14)};
        border-radius: ${ms(10)};
        padding: ${ms(5)};
      `;
    case 'sm':
      return css<SizeStyleProps>`
        min-height: ${ms(32)};
        height: ${ms(32)};
        min-width: auto;
        font-size: ${ms(14)};
        border-radius: ${ms(8)};
      `;
    case 'xs':
      return css<SizeStyleProps>`
        min-height: ${ms(24)};
        height: ${ms(24)};
        min-width: auto;
        font-size: ${ms(10)};
        border-radius: ${ms(8)};
        padding: 0 ${ms(4)};
      `;
    case 'me':
    default:
      return css<SizeStyleProps>`
        min-height: ${ms(40)};
        height: ${ms(40)};
        min-width: ${ms(200)};
        font-size: ${ms(14)};
        border-radius: ${ms(10)};
        padding: ${ms(5)};
      `;
  }
};

export const baseStyles = {
  menuPortal: base => ({...base, zIndex: 9999}),
};

export const Container = styled(View)<SelectV2.StyledProps>`
  position: relative;
  display: block;

  .react-select__control {
  }

  .react-select__input {
    color: ${getColor('text.black')} !important;
  }

  .react-select__placeholder {
    color: ${getColor('text.gray')} !important;
  }

  .react-select__indicator {
    padding: 0;
    padding-right: ${ms(8)};

    &:first-child {
      padding-left: ${ms(8)};
    }
  }
`;
